import { render, staticRenderFns } from "./footerLogo.vue?vue&type=template&id=ed729876&scoped=true&"
import script from "./footerLogo.vue?vue&type=script&lang=js&"
export * from "./footerLogo.vue?vue&type=script&lang=js&"
import style0 from "./footerLogo.vue?vue&type=style&index=0&id=ed729876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed729876",
  null
  
)

export default component.exports